import constants from '../services/constants';
import { atom } from 'recoil';

const animMoveAtom = atom<{fromIndex: number,toIndex: number} | null>({
    key: constants.pathsAtom,
    default: null,
});

export default animMoveAtom;